import { MOEDAS, dataDaCotacao, definirMoeda, useEstadoMoeda, type Moeda } from '../../../utils/moedaSite';
import styles from './SeletorIdiomas.module.css';

// cs2504 (05/10): select MANUAL de moeda no topo 3, ao lado do seletor de idiomas (R$/US$/€/BTC/ETH).
// Os preços dos imóveis (PrecoMoeda) acompanham a escolha. Gate: temSeletorMoedaManual (só o 2504);
// os demais tenants seguem a moeda do idioma (utils/moedaSite).
const SeletorMoeda: React.FC = () => {
    const est = useEstadoMoeda();
    const quando = dataDaCotacao(est);
    return (
        <select
            className={`notranslate ${styles.moeda}`}
            translate="no"
            aria-label="Moeda dos preços"
            title={quando ? `Cotação de ${quando} · valores aproximados` : 'Moeda dos preços'}
            value={est.moeda}
            onChange={(e) => definirMoeda(e.target.value as Moeda)}
        >
            {MOEDAS.map((m) => (
                <option key={m.codigo} value={m.codigo}>
                    {`${m.simbolo} ${m.codigo}`}
                </option>
            ))}
        </select>
    );
};

export default SeletorMoeda;
